<template>
    <form @submit.prevent="onSubmit" class="form-horizontal form-material">
        <div class="card text-white bg-danger" v-if="showFailureMessage">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Validation Errors</h4></div>
            <div class="card-body">
                <p v-if="typeof errors === 'string'" class="card-text">{{errors}}</p>
                <p v-else class="card-text" v-for="(error, key) in errors" :key="key">
                    {{key}}: {{error}}
                </p>
            </div>
        </div>
        <br/>

        <div class="mb-5" v-if="this.$store.getters.isAdmin">
            <label>Owner:</label>
            <treeselect placeholder="Select"
                        v-model="server.user"
                        :multiple="false"
                        :options="userList"
                        :load-options="loadUserList"
                        value-format="object"
            />
        </div>
        <div class="form-group">
            <label class="my-1">Server Name</label>
            <input v-model="server.name" type="text" class="form-control">
            <div v-if="$v.server.name.$error">
                <div class="text-danger" v-if="!$v.server.name.required">Server Name is required.</div>
            </div>
        </div>
        <div class="form-group">
            <label class="mb-1">Host</label>
            <input v-model="server.host" type="text" class="form-control">
            <div v-if="$v.server.host.$error">
                <div class="text-danger" v-if="!$v.server.host.required">Server HOST is required.</div>
            </div>
        </div>
        <div class="form-group">
            <label class="mb-1">Port</label>
            <input v-model.number="server.port" type="text" class="form-control">
            <div v-if="$v.server.port.$error">
                <div class="text-danger" v-if="!$v.server.port.required">Port is required.</div>
                <div class="text-danger" v-if="!$v.server.port.integer">Port must be integer.</div>
            </div>
        </div>
        <div class="form-group">
            <label class="mb-1">Default normal relay speed(seconds between sending).</label>
            <input v-model.number="server.relayNormalSpeed" type="text" class="form-control">
            <div v-if="$v.server.relayNormalSpeed.$error">
                <div class="text-danger" v-if="!$v.server.relayNormalSpeed.required">Normal Relay speed is required.</div>
                <div class="text-danger" v-if="!$v.server.relayNormalSpeed.integer">Normal Relay speed must be integer.</div>
            </div>
        </div>
        <div class="form-group">
            <label class="mb-1">Default backoff relay speed(seconds between sending).</label>
            <input v-model.number="server.relayBackoffSpeed" type="text" class="form-control">
            <div v-if="$v.server.relayBackoffSpeed.$error">
                <div class="text-danger" v-if="!$v.server.relayBackoffSpeed.required">Backoff Relay speed is required.</div>
                <div class="text-danger" v-if="!$v.server.relayBackoffSpeed.integer">Backoff Relay speed must be integer.</div>
            </div>
        </div>
        <div class="form-group">
            <label class="custom-control custom-checkbox m-b-0">
                <input v-model="server.tls" type="checkbox" class="custom-control-input">
                <span class="custom-control-label">TLS</span>
            </label>
        </div>
        <div class="form-group text-center p-b-20">
            <div class="col-xs-12">
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light" v-show="!submitting">
                    Save
                </button>
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light" disabled
                        v-show="submitting">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Submitting...
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import {integer, required} from 'vuelidate/lib/validators';
    import SmtpServerService from '../../services/SmtpServerService';
    import Treeselect from '@riophae/vue-treeselect';
    import UserService from '../../services/UserService';

    export default {
        name: 'SmtpServerForm',
        props: ['id'],
        components: {Treeselect},
        data() {
            return {
                server: {
                    name: null,
                    host: null,
                    port: 25,
                    tls: false,
                    relayNormalSpeed: 60,
                    relayBackoffSpeed: 600,
                    user: null
                },
                errors: {},
                showFailureMessage: false,
                userList: null,
                submitting: false,
            }
        },
        mounted() {
            if (this.id) {
                SmtpServerService.getServer(this.id).then(response => {
                    this.server = response.data;
                    this.$emit('hidePreloader', false)
                });
            }
        },
        validations: {
            server: {
                name: {required},
                host: {required},
                port: {required, integer},
                relayNormalSpeed: {required, integer},
                relayBackoffSpeed: {required, integer},
                tls: {required},
            }
        },
        methods: {
            onSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid) return;
                if (!this.server.user) {
                    delete this.server.user;
                }

                this.submitting = true;
                let submitMethod = null;
                if (this.id) {
                    submitMethod = SmtpServerService.updateServer(this.id, JSON.stringify(this.server));
                } else {
                    submitMethod = SmtpServerService.createServer(JSON.stringify(this.server));
                }

                submitMethod.then(response => {
                    if ([200, 201].includes(response.status)) {
                        this.$router.push({name: 'smtpServers'});
                    }
                    this.submitting = false;
                    this.errors = response.data.error !== undefined ? response.data.error : 'Some error occurred.';
                    this.showFailureMessage = true;
                });
            },
            loadUserList({callback}) {
                UserService.getUserSelect().then(response => {
                    this.userList = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                    callback();
                });
            }
        }
    }
</script>

<style scoped>

</style>
